var map = {
	"./air-conditioner.svg": 1198,
	"./airplane.svg": 1199,
	"./airport.svg": 1200,
	"./approved.svg": 1201,
	"./aquapark.svg": 1202,
	"./arrow-answer-bubble.svg": 1203,
	"./arrow-back.svg": 1204,
	"./arrow-flight.svg": 1205,
	"./arrow-right-top.svg": 1206,
	"./arrow-right.svg": 1207,
	"./bar.svg": 1208,
	"./beach-surface-pebble.svg": 1209,
	"./beach-surface-platform.svg": 1210,
	"./beach-surface-sand-pebble.svg": 1211,
	"./beach-surface-sand.svg": 1212,
	"./beachsurface.svg": 1213,
	"./card.svg": 1214,
	"./check.svg": 1215,
	"./clock.svg": 1216,
	"./cvv.svg": 1217,
	"./double-arrow.svg": 1218,
	"./empty-hotel-map.svg": 1219,
	"./filters/clear-filters.svg": 1220,
	"./filters/filter-button.svg": 1221,
	"./filters/instant-confirm-colored.svg": 1222,
	"./filters/instant-confirm.svg": 1223,
	"./filters/search-distance.svg": 1224,
	"./filters/search-lift.svg": 1225,
	"./fire.svg": 1226,
	"./flight-direct-mobile.svg": 1227,
	"./flight-direct.svg": 1228,
	"./flight-direct__additional-mobile.svg": 1229,
	"./flight-direct__additional.svg": 1230,
	"./flight-transition-mobile.svg": 1231,
	"./flight-transition.svg": 1232,
	"./flight-transition__additional-mobile.svg": 1233,
	"./flight-transition__additional.svg": 1234,
	"./food.svg": 1235,
	"./free-cancellation-colored.svg": 1236,
	"./fuel-green.svg": 1237,
	"./fuel-white.svg": 1238,
	"./funicular.svg": 1239,
	"./gallery-empty.svg": 1240,
	"./garranty.svg": 1241,
	"./gender-female.svg": 1242,
	"./gender-male.svg": 1243,
	"./gender-unidentified.svg": 1244,
	"./gift.svg": 1245,
	"./glass.svg": 1246,
	"./gym.svg": 1247,
	"./hand-luggage.svg": 1248,
	"./heated-pool.svg": 1249,
	"./hold-luggage.svg": 1250,
	"./hotel-reply.svg": 1251,
	"./included-services.svg": 1252,
	"./included.svg": 1253,
	"./kids-club.svg": 1254,
	"./kids-menu.svg": 1255,
	"./kids-pool.svg": 1256,
	"./lightning.svg": 1257,
	"./lock.svg": 1258,
	"./logo.svg": 1259,
	"./lt-extra/bonus_insurance.svg": 1260,
	"./lt-extra/bonus_ivi.svg": 1261,
	"./luggage-wrapping.svg": 1262,
	"./man.svg": 1263,
	"./map-button.svg": 1264,
	"./map/collapse-arrows.svg": 1265,
	"./map/expand-arrows.svg": 1266,
	"./massage.svg": 1267,
	"./nanny.svg": 1268,
	"./only-lt-half.svg": 1269,
	"./parking.svg": 1270,
	"./payment-mir.svg": 1271,
	"./paymenttype.svg": 1272,
	"./plane-arrival.svg": 1273,
	"./plane.svg": 1274,
	"./private-beach.svg": 1275,
	"./rest_types/active.svg": 1276,
	"./rest_types/couples.svg": 1277,
	"./rest_types/family.svg": 1278,
	"./review-tab-selected.svg": 1279,
	"./sauna.svg": 1280,
	"./search-sorting.svg": 1281,
	"./searcher-empty-request.svg": 1282,
	"./searcher-filtered-empty.svg": 1283,
	"./sidebar-bottom-triangle.svg": 1284,
	"./sidebar-menu-active.svg": 1285,
	"./sign_additional.svg": 1286,
	"./ski-in-ski-out.svg": 1287,
	"./social-fb.svg": 1288,
	"./social-share.svg": 1289,
	"./social-vk.svg": 1290,
	"./special.svg": 1291,
	"./success_additional.svg": 1292,
	"./swimming-pool.svg": 1293,
	"./thumbs-up.svg": 1294,
	"./wave.svg": 1295,
	"./wifi.svg": 1296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;